import { render, staticRenderFns } from "./FlagComponent.vue?vue&type=template&id=24dd3631&scoped=true&"
import script from "./FlagComponent.vue?vue&type=script&lang=js&"
export * from "./FlagComponent.vue?vue&type=script&lang=js&"
import style0 from "./FlagComponent.vue?vue&type=style&index=0&id=24dd3631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd3631",
  null
  
)

export default component.exports